import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiX, FiAlertCircle, FiInfo } = FiIcons;

const Toast = () => {
  const [toasts, setToasts] = useState([]);

  // 全局 toast 函數
  window.showToast = (message, type = 'info') => {
    const id = Date.now();
    const toast = { id, message, type };
    
    setToasts(prev => [...prev, toast]);
    
    // 3秒後自動移除
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 3000);
  };

  const removeToast = (id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  };

  const getToastIcon = (type) => {
    switch (type) {
      case 'success':
        return FiCheck;
      case 'error':
        return FiX;
      case 'warning':
        return FiAlertCircle;
      default:
        return FiInfo;
    }
  };

  const getToastColor = (type) => {
    switch (type) {
      case 'success':
        return 'bg-green-600';
      case 'error':
        return 'bg-red-600';
      case 'warning':
        return 'bg-orange-600';
      default:
        return 'bg-gray-800';
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2">
      <AnimatePresence>
        {toasts.map((toast) => (
          <motion.div
            key={toast.id}
            className={`
              ${getToastColor(toast.type)} text-white px-4 py-3 rounded-lg shadow-lg
              flex items-center gap-3 max-w-sm cursor-pointer
            `}
            onClick={() => removeToast(toast.id)}
            initial={{ opacity: 0, x: 100, scale: 0.8 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 100, scale: 0.8 }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
          >
            <SafeIcon 
              icon={getToastIcon(toast.type)} 
              className="w-5 h-5 flex-shrink-0" 
            />
            <span className="text-sm font-medium">{toast.message}</span>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default Toast;